<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="m-0" id="toClick">{{ parentData.title }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div
    class="main_div"
    *ngIf="entitySubscriptionHistoryData.length > 0 && toShowExistingPlans"
  >
    <div class="main_div_sub_div">
      <div
        class="business_subs"
        *ngFor="let item of entitySubscriptionHistoryData"
      >
        <h3>{{ item.planName }}</h3>
        <p>{{ item.planDescription }}</p>
        <span>Purchased on:</span>
        <p>{{ item.creationDate | date }}</p>
        <span>No of employees used for:</span>
        <p>{{item.noOfUsersActivate}}/{{item.noOfUsers}}</p>
        <span>Validity:</span>
        <p>{{ item.validity }} days</p>
        <div class="btn-cont">
          <button
            mat-flat-button
            (click)="createBusinessWithExistingSubs(item)"
          >
            Select Pack
          </button>
        </div>
      </div>
      <div class="add_new_btn">
        <button mat-flat-button color="accent" (click)="addNewSubs()">
          Add New Pack
        </button>
      </div>
    </div>
  </div>

  <div class="plans_div" *ngIf="plansList.length > 0 && toShowPlatformPlans">
    <div class="plans_sub_div" *ngFor="let item of plansList">
      <div
        class="platform_subs"
        (click)="onSelectPlan(item)"
        [ngClass]="{ make_grey_bg: item.isExpired == 1 }"
      >
        <h1>{{ item.title }}</h1>
        <mat-icon class="mat-18" [ngClass]="{ selected: item.selected == true }"
          >check_circle</mat-icon
        >
        <h1 style="font-size: 3rem; font-weight: 500; margin: 23px 0">
          Rs. {{ item.perUnitCost }}
        </h1>
        <h2 style="margin-bottom: 5px">{{ item.validity }} validity</h2>
        <h3 style="margin: 0">{{ item.description }}</h3>
      </div>
    </div>
  </div>

  <div class="business_form" *ngIf="toShowForm">
    <div class="business_form_sub_div">
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput #input [(ngModel)]="newEmployeeObj.requestUserName" />
        </mat-form-field>
      </div>
          <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker1.open()" style="padding: 0px;">
              <mat-label>Starting Date</mat-label>
              <input matInput [matDatepicker]="picker1" [(ngModel)]="newEmployeeObj.joiningDate" readonly>
              <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1 disabled="false"></mat-datepicker>
            </mat-form-field>
            <div>
              <mat-form-field appearance="outline">
                <mat-label>Salary</mat-label>
                <input matInput #input [(ngModel)]="newEmployeeObj.joiningSalary" />
              </mat-form-field>
            </div>
      <div class="radio_group">
          <label>Salary Type: </label>
          <mat-radio-group [(ngModel)]="newEmployeeObj.salaryType">
            <mat-radio-button value="Male">Monthly</mat-radio-button>
            <mat-radio-button value="Female">Daily</mat-radio-button>
            <mat-radio-button value="Others">Hourly</mat-radio-button>
          </mat-radio-group>
        </div>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Phone Number</mat-label>
            <input matInput #input [(ngModel)]="newEmployeeObj.requestUserPhone" />
          </mat-form-field>
        </div>
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <textarea
            matInput
            #input
            [(ngModel)]="newEmployeeObj.note"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="toShowForm">
  <button mat-button (click)="goBack()">Back</button>
  <button mat-flat-button color="accent" (click)="onSubmit()">{{editmode ? 'Edit' : 'Create'}}</button>
</mat-dialog-actions>
<mat-dialog-actions align="end" *ngIf="toShowPlatformPlans">
  <div style="position: relative; left: -80px; top: 3px" *ngIf="toShowMonths">
    <span style="position: relative; top: -8px; margin-right: 10px"
      >No. of Months</span
    >
    <button
      (click)="changeNoOfMonths(0)"
      style="
        border: none;
        background: #fff;
        position: relative;
        top: -2px;
        font-size: 22px;
        left: 21px;
      "
      [disabled]="noOfMonths == 1"
      
    >
      <mat-icon
        class="material-icons-round try"
        [ngStyle]="{'color': noOfMonths == 1 ? 'lightgray' : '#ffbf00'}"
        [inline]="true"
        >do_not_disturb_on</mat-icon
      >
    </button>
    <input type="text" [(ngModel)]="noOfMonths" style="width: 30px!important;
    height: 30px!important;
    border: none;
    padding: 0;
    text-align: center;
    background: #fff;
    position: relative;
    top: -8px;
    left: 21px;
">
    <button
      (click)="changeNoOfMonths(1)"
      style="
        border: none;
        background: #fff;
        position: relative;
        top: -2px;
        font-size: 22px;
        left: 21px;
      "
    >
      <mat-icon
        class="material-icons-round try"
        style="color: #ffbf00"
        [inline]="true"
        >add_circle</mat-icon
      >
    </button>
  </div>
  <button mat-button mat-dialog-close >Cancel</button>
  <button mat-flat-button color="accent" (click)="onContinue()" >
    Continue
  </button>
  <div style="position: relative; left: -234px; top: 3px" *ngIf="toShowMonths">
      <span style="position: relative; top: -8px; margin-right: 11px"
        >No. of Employees</span
      >
      <button
        (click)="changeNoOfEmployees(0)"
        style="
          border: none;
          background: #fff;
          position: relative;
          top: -2px;
          font-size: 22px;
          left: 1px;
        "
        [disabled]="noOfEmployees == 1"
        
      >
        <mat-icon
          class="material-icons-round try"
          [ngStyle]="{'color': noOfEmployees == 1 ? 'lightgray' : '#ffbf00'}"
          [inline]="true"
          >do_not_disturb_on</mat-icon
        >
      </button>
      <input type="text" [(ngModel)]="noOfEmployees" style="width: 30px!important;
      height: 30px!important;
      border: none;
      padding: 0;
      text-align: center;
      background: #fff;
      position: relative;
      top: -8px;
      left: 1px;
  ">
      <button
        (click)="changeNoOfEmployees(1)"
        style="
          border: none;
          background: #fff;
          position: relative;
          top: -2px;
          font-size: 22px;
          left: 1px;
        "
      >
        <mat-icon
          class="material-icons-round try"
          style="color: #ffbf00"
          [inline]="true"
          >add_circle</mat-icon
        >
      </button>
    </div>
</mat-dialog-actions>
